const API_KEY = {
  predictions: "NPOFl9G0ayhi2T8YZxpR6d5UrIfRccs0k7Q6eqvnS2Ghfq/g/EhKpg==",
  routes: "IHmqNz1AD3OFU0wpZk4DUpqt4N621wuShxBggtdWdxnlw8t3qTV7Jg==",
  dailySchedule: "U6pXjBepeZuwJl3JP403ZJ6AOWJd/mQxvwiwcoAxxid8rk9P1YER5A==",
  car: "h31UoRbyRx31U8VykECJaOuzizI7aaWTAlxoOiI0Y1GBnfspIdeFUg==",
  smoothRoutes: "EQCSMhiUBup4PjWa0yYSEmaLVKRJqKqaolFAdemLzVZBv/EvZ8KXQw==",
  traffic: "bpmWDx2yqHCa66y6Hfx1SKOe4QcfNAlK/WyXkI5mIbqAYUv88CM6vg==",
  settings: "S5z6NwieY44qmWhWwJ/QWXlJBkasyg/OdMXmfH/fw3KabSf9r1XjMg==",
  court: "tuI7sahRYdHhk5XuuOTFSPNXDxx5exj7xv5AowEYXwgvNyIomTvuCA==",
};

const LANGUAGES = {
  appTitle: {
    zh: "穿梭巴士服務",
    en: "Shuttle Bus Service",
    cn: "穿梭巴士服务",
  },
  appTitleRmb: {
    zh: "公共小巴服務",
    en: "Minibus Service",
    cn: "公共小巴服务",
  },
  routesTitle: {
    zh: "路線",
    en: "Routes",
    cn: "路线",
  },
  feeText: {
    zh: "車費",
    en: "Fee",
    cn: "车费",
  },
  minute: {
    zh: "分鐘",
    en: "Min",
    cn: "分钟",
  },
  scheduleText: {
    zh: "下一班",
    en: "Scheduled",
    cn: "下一班",
  },
  arrivingText: {
    zh: "即將抵達",
    en: "Arriving",
    cn: "即将抵达",
  },
  nextText: {
    zh: "下一班",
    en: "Next",
    cn: "下一班",
  },
  nonStop: {
    zh: "不經愛丁堡",
    en: "No Edinburgh Place Stop",
    cn: "不经爱丁堡",
  },
  scheduleTitle: {
    zh: "班次",
    en: "Schedule",
    cn: "班次",
  },
  MonToSat: {
    zh: "星期一至六",
    en: "Monday to Saturday",
    cn: "星期一至六",
  },
  SunAndHol: {
    zh: "星期日及公眾假期",
    en: "Sunday & Public Holiday",
    cn: "星期日及公众假期",
  },
  HomePageTitle: {
    zh: "首頁",
    en: "Home",
    cn: "首页",
  },
  EtaPageTitle: {
    zh: "預報",
    en: "Time",
    cn: "预报",
  },
  SchedulePageTitle: {
    zh: "班次",
    en: "Schedule",
    cn: "班次",
  },
  ErrMsg: {
    zh: "系統更新中，請稍後再試",
    en: "System updating, please try again later.",
    cn: "系统更新中，请稍后再试",
  },
  ErrRouteMsg: {
    zh: "沒有此路線",
    en: "Invalid route",
    cn: "没有此路线",
  },
  heavyTraffic: {
    zh: "行車緩慢",
    en: "Traffic congestion",
    cn: "行车缓慢",
  },
  waiting: {
    zh: "等客中",
    en: "Waiting",
    cn: "等客中",
  },
  descriptionRealTimeEta: {
    zh: "顏色數字代表實時班次，該巴士已經出發",
    en: "Coloured number refers to real time ETA, which means the bus is on its way",
    cn: "颜色数字代表实时班次，该巴士已经出发",
  },
  descriptionScheduleEta: {
    zh: "灰色數字代表預定班次，該巴士並未出發",
    en: "Grey number refers to scheduled time, which means the bus hasn't started its trip yet",
    cn: "灰色数字代表预定班次，该巴士并未出发",
  },
  descriptionRealTimeEtaRmb: {
    zh: "顏色數字代表實時班次，該小巴已經出發",
    en: "Coloured number refers to real time ETA, which means the minibus is on its way",
    cn: "颜色数字代表实时班次，该小巴已经出发",
  },
  descriptionScheduleEtaRmb: {
    zh: "灰色數字代表預定班次，該小巴並未出發",
    en: "Grey number refers to scheduled time, which means the minibus hasn't started its trip yet",
    cn: "灰色数字代表预定班次，该小巴并未出发",
  },
  descriptionGoodTraffic: {
    zh: "綠色線代表交通暢順",
    en: "Green line refers to light traffic",
    cn: "绿色线代表交通畅顺",
  },
  descriptionAverageTraffic: {
    zh: "橙色線代表交通大致暢順",
    en: "Orange line refers to medium traffic",
    cn: "橙色线代表交通挤塞",
  },
  descriptionSlowTraffic: {
    zh: "紅色線代表交通擠塞",
    en: "Red line refers to heavy traffic",
    cn: "红色线代表交通严重挤塞",
  },
  descriptionDeadSlowTraffic: {
    zh: "深紅色線代表交通嚴重擠塞",
    en: "Dark Red line refers to very heavy traffic",
    cn: "深红色线代表交通严重挤塞",
  },
  tips: {
    zh: "使用指南",
    en: "Tips",
    cn: "使用指南",
  },
  maintenance: {
    zh: "系統維護中，預報暫停",
    en: "ETA is stopped due to system maintenance.",
    cn: "系统维护中，预报暂停",
  },
  distruption: {
    zh: "公眾活動進行中，預報暫停",
    en: "ETA is stopped due to public procession.",
    cn: "公众活动进行中，预报暂停",
  },
  language: {
    zh: "語言",
    en: "Language",
    cn: "语言",
  },
  scheduled: {
    zh: "預定班次",
    en: "Scheduled",
    cn: "预定班次",
  },
  noScheduled: {
    zh: "暫時沒有預定班次",
    en: "No scheduled departure at the moment",
    cn: "暂时没有预定班次",
  },
  start: {
    zh: "起點",
    en: "Start",
    cn: "起点",
  },
  end: { zh: "終點", en: "End", cn: "终点" },
  weekdays: [
    { zh: "", en: "", cn: "" },
    { zh: "星期一", en: "Mon", cn: "星期一" },
    { zh: "星期二", en: "Tue", cn: "星期二" },
    { zh: "星期三", en: "Wed", cn: "星期三" },
    { zh: "星期四", en: "Thur", cn: "星期四" },
    { zh: "星期五", en: "Fri", cn: "星期五" },
    { zh: "星期六", en: "Sat", cn: "星期六" },
    { zh: "星期日", en: "Sun", cn: "星期日" },
    { zh: "公眾假期", en: "Public Holiday", cn: "公众假期" },
  ],
  notOperateToday: {
    zh: "是日沒有提供服務",
    en: "Not in service ",
    cn: "是日没有提供服务",
  },
  notOperateThatDay: {
    zh: "當日沒有提供服務",
    en: "Not in service  ",
    cn: "当日没有提供服务",
  },
  youAreHere: {
    zh: "你在此",
    en: "You are Here",
    cn: "你在此",
  },
  seatsLeft: {
    zh: "剩餘座位",
    en: "Seats Left",
    cn: "剩余座位",
  },
};

export default {
  API_KEY,
  LANGUAGES,
};
